/* eslint-disable max-len */
import { GetSessionCreds } from '@/redux/actions/authActions';
// import { encrypt } from '@/utils/LocalStorage/localStorageED';

// const SECRET_CODE = import.meta.env.VITE_REACT_STN_SECRET_KEY;

/**
 * Cross Domain Reauthentication Workflow (Concept):
 * VITE_REACT_ALT_URLS is a comma-separated list of urls for the portal
 * 1. User opens link to Site A
 * 2. Site A (tab 1) opens tab to Site B (tab 2) requesting session cookie
 * 3. If Site B has session cookie, it will redirect (tab 2) to Site A with the session cookie
 * 4. Site A (tab 2) will set the session cookie
 * 5. Site A (tab 1) will close tab 2 and redirect to the home page after 5 seconds
 * 6. If Site A (tab 1) has session cookie, it will use the session cookie to get the credentials
 * 7. If Site A (tab 1) does not have session cookie, it will redirect to the login page
 */

export const authCookies = (isLoggedIn, navigate, dispatch) => {
	const cookies = getCookies();

	if (cookies?.skipCacheRedirect) {
		return;
	}

	// // For Cross Domain Reauthentication Workflow, testing
	// const queryParams = new URLSearchParams(window.location.search);
	// const mode = queryParams.get('mode');
	// let otherUrl = queryParams.get('redirect');
	// if (!otherUrl) {
	//   otherUrl = (import.meta.env.VITE_REACT_ALT_URLS || '').split(',').find((url) => url !== window.location.origin);
	// }

	// if (otherUrl) {
	//   if (mode === 'query_cookie') {
	//     passCookieToOtherSite(otherUrl, cookies);
	//   } else if (mode === 'set_cookie') {
	//     setCookieFromOtherSite();
	//   } else if (!isLoggedIn && !cookies?.checkedRedirect) {
	//     if (!cookies?.session && !cookies?.redirectSession) {
	//       initGetCookieFromOtherSite(otherUrl, navigate);
	//     }
	//   }
	// }

	if (
		!isLoggedIn &&
		(cookies?.session || cookies?.sessionID || cookies?.redirectSession)
	) {
		// Get user credentials for session (if from redirected session, copy credentials to new session)
		dispatch(
			GetSessionCreds(
				cookies?.sessionID || cookies?.redirectSession,
				cookies?.session || cookies?.sessionID ? false : true,
				() => navigate('/tickets/'),
			),
		);
		document.cookie = `redirectSession=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;samesite=none;secure;`;
	}
};

export const getCookies = () => {
	const cookies = document.cookie.split('; ');
	let cookieObj = {};
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();
		const eqPos = cookie.indexOf('=');
		const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		cookieObj[name] = eqPos > -1 ? cookie.substr(eqPos + 1) : '';
		// if (name === 'sessionID') {
		// 	// cookieObj[name] = decrypt(atob(cookieObj[name]), SECRET_CODE);
		// 	cookieObj[name] = cookieObj[name];
		// }
	}
	return cookieObj;
};

const initGetCookieFromOtherSite = (otherUrl, navigate) => {
	// Set checkedRedirect=true to skip redirect check on next page load
	document.cookie = `checkedRedirect=true;path=/;samesite=none;secure;`;
	const redirectWindow = window.open(
		otherUrl +
			'/login?mode=query_cookie&redirect=' +
			window.location.origin.trimEnd('/'),
		'_blank',
	);
	// Close redirect window and navigate to home page after 5 seconds to refresh credentials
	setTimeout(function () {
		redirectWindow.close();
		navigate('/');
	}, 1500);
};

const passCookieToOtherSite = (otherUrl, cookies) => {
	if (cookies?.session) {
		window.location.href =
			otherUrl + '/login?mode=set_cookie&session=' + cookies?.session;
	} else {
		window.close();
	}
};

const setCookieFromOtherSite = () => {
	const queryParams = new URLSearchParams(window.location.search);
	const session = queryParams.get('session');
	if (session) {
		document.cookie = `redirectSession=${session};path=/;samesite=none;secure;`;
	}
	window.close();
};

export const setSessionCookie = credentials => {
	const now = new Date(credentials?.refreshExp);
	// document.cookie = `sessionID=${btoa(encrypt(credentials?.session, SECRET_CODE))};expires=${now.toUTCString()};path=/;samesite=none;secure;`;
	document.cookie = `sessionID=${credentials?.session};expires=${now.toUTCString()};path=/;samesite=none;secure;`;
};

export const clearCookies = () => {
	// Clear all cookies, set skipCacheRedirect=true to prevent immediate reauthentication
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i];
		const eqPos = cookie.indexOf('=');
		const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
	}
	const now = new Date();
	now.setTime(now.getTime() + 10 * 1000);
	document.cookie = `skipCacheRedirect=true;expires=${now.toUTCString()};path=/;samesite=none;secure;`;

	setTimeout(() => {
		document.cookie = `checkedRedirect=true;path=/;samesite=none;secure;`;
	}, 2000);
};
